/* JAYKEI split section: figure fade-up + dashed rule draw on enter,
   and opposing horizontal parallax on the two ghost words while scrolling. */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initEnter(root) {
    if (reduced || !('IntersectionObserver' in window)) return;
    root.dataset.anim = 'ready';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, {
      threshold: 0.35,
      // Pull the trigger line up off the fold: at 1440x900 the section is already
      // ~28% visible on arrival, so a bare threshold fired before anyone scrolled.
      rootMargin: '0px 0px -12% 0px'
    });
    root.querySelectorAll('[data-panel]').forEach(function (p) { io.observe(p); });
  }

  function initParallax(root) {
    if (reduced) return;
    var words = [].slice.call(root.querySelectorAll('.jk-split__word'));
    if (!words.length) return;

    var ticking = false, visible = false;

    function apply() {
      ticking = false;
      if (!visible) return;
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // -1 as the section enters from the bottom, +1 once it has left the top
      var p = ((vh - rect.top) / (vh + rect.height)) * 2 - 1;
      p = Math.max(-1, Math.min(1, p));
      words.forEach(function (w) {
        var dir = w.dataset.dir === 'left' ? -1 : 1;
        var amt = parseFloat(w.dataset.amount || '60');
        w.style.setProperty('--jk-wx', (p * amt * dir).toFixed(1) + 'px');
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        visible = e[0].isIntersecting;
        if (visible) apply();
      }, { rootMargin: '120px' }).observe(root);
    } else { visible = true; }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  }

  function init() {
    document.querySelectorAll('[data-jk-split]').forEach(function (root) {
      if (root.dataset.init === '1') return;
      root.dataset.init = '1';
      initEnter(root);
      initParallax(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
